module.exports = __webpack_public_path__ + "img/bubble-dictation.fc86a244.webp";